module.exports = __webpack_public_path__ + "img/sites.15652cb9.svg";